/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, Icon } from 'semantic-ui-react';
import todaysDate from 'utils/todaysDate';
import formatNumber from 'helpers/formatNumber';

const GroupGenders = ({
  data: {
    males_count: malesCount,
    females_count: femalesCount,
    groups_members_count: groupMembersCount,
  },
  year,
}) => {
  return (
    <Grid className="group-genders">
      <Grid.Row columns="1">
        <Grid.Column width="16">
          <Card className="Total__members">
            <Card.Content>
              <div className="Total__members__top">
                <div className="Total__members__top__header">
                  <h1 className="Total__members__title">
                    Total Members
                  </h1>
                  <Card.Meta>{todaysDate(year)}</Card.Meta>
                </div>
                <div className="Total__members__top__icon">
                  <Icon name="female" size="big" />
                  <Icon name="male" size="big" />
                </div>
              </div>
              <Card.Description className="Total__members__description">
                {formatNumber(groupMembersCount)}
              </Card.Description>
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns="1">
        <Grid.Column width="16">
          <Card className="Total__members">
            <Card.Content>
              <div className="Total__members__top">
                <div className="Total__members__top__header">
                  <h1 className="Total__members__title">
                    Female members
                  </h1>
                  <Card.Meta>{todaysDate(year)}</Card.Meta>
                </div>
                <div className="Total__members__top__icon">
                  <Icon name="female" size="big" />
                </div>
              </div>
              <Card.Description className="Total__members__description">
                {formatNumber(femalesCount)}
              </Card.Description>
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns="1">
        <Grid.Column width="16">
          <Card className="Total__members">
            <Card.Content>
              <div className="Total__members__top">
                <div className="Total__members__top__header">
                  <h1 className="Total__members__title">
                    Male members
                  </h1>
                  <Card.Meta>{todaysDate(year)}</Card.Meta>
                </div>
                <div className="Total__members__top__icon">
                  <Icon name="male" size="big" />
                </div>
              </div>
              <Card.Description className="Total__members__description">
                {formatNumber(malesCount)}
              </Card.Description>
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

GroupGenders.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
  year: PropTypes.string.isRequired,
};

export default GroupGenders;
